import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import useSavePatient from "src/Patient/hooks/useSavePatient";
import {
  errorsReservationGuestState,
  valuesFormRegisterState,
  valuesFormReservationGuestState,
} from "src/Patient/state/atoms";
import ReservationService from "src/services/agenda/reservations";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { snackbarState } from "src/store/global/snackbarState";
import {
  hourSelectedState,
  showModalReservationState,
} from "src/store/reservation/reservationState";
import { userState } from "src/store/user/userState";
import { ReservationSchema } from "../schemas/ReservationSchema";
import { activeTabReservationState } from "../state/atoms";
import {
  existPatientState,
  filterSearchSelectedState,
} from "src/SearchHours/state/atoms";
import { slugQuery } from "src/shared/global/helpers";

export const useSaveReservation = () => {
  const { catchErrorApi } = useCatchErrorApi();
  //const history = useNavigate();
  const navigate = useNavigate();
  const [loadingSaved, setLoadingSaved] = useState(false);
  const [hourSelected, setHourSelected] = useRecoilState(hourSelectedState);
  const setSnackbar = useSetRecoilState(snackbarState);
  const [showModal, setShowModal] = useRecoilState(showModalReservationState);
  const activeTabReservation = useRecoilValue(activeTabReservationState);
  const errorsReservationGuest = useRecoilValue(errorsReservationGuestState);
  const setErrorsReservationGuest = useSetRecoilState(
    errorsReservationGuestState
  );
  const [valuesFormReservationGuest, setValuesFormReservationGuest] =
    useRecoilState(valuesFormReservationGuestState);
  const valuesFormRegister = useRecoilValue(valuesFormRegisterState);
  const user = useRecoilValue(userState);
  const { handleLoginUser } = useAuthPatient();
  const { handleValidatePhones, handleValidateEmails } = useSavePatient();
  const existPatient = useRecoilValue(existPatientState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  console.log(filterSearchSelected, "cambio url");
  console.log(hourSelected, "cambio url");
  const handleClickSaveReservation = async () => {
    setLoadingSaved(true);

    let restPropertiesReservation = {};
    let userStorage = user.payload || null;
    let findErrors = false;
    try {
      let dataForReservation = {
        ptdRut: hourSelected?.professional?.ptdRut,
        agpCorrel: hourSelected?.hourSelected?.agpCorrel,
        ageCorrel: hourSelected?.hourSelected?.ageCorrel,
        cmnCodigo: hourSelected?.hourSelected?.cmnCodigo,
        ageOrigen: "W",
      };

      if (activeTabReservation === "1" && !user.isAuthenticated) {
        const userLogin = await handleLoginUser();
        userStorage = { ...userLogin };
      }

      if (
        activeTabReservation === "2" &&
        !user.isAuthenticated &&
        !existPatient
      ) {
        const reservationSchema = new ReservationSchema();
        const bodyValidate = await reservationSchema.isValidSchema({
          ...valuesFormReservationGuest,
          isaCodigo: valuesFormRegister["isaCodigo"],
        });
        const emailErrors =
          valuesFormReservationGuest.ageEmail !==
            valuesFormReservationGuest.ageEmailConfirm ||
          valuesFormReservationGuest.ageEmail === "" ||
          valuesFormReservationGuest.ageEmail === null;
        findErrors = (await handleValidatePhones()) || emailErrors;

        if (bodyValidate.ok === false || findErrors) {
          findErrors = true;
          setErrorsReservationGuest((currentState) => ({
            ...currentState,
            ...bodyValidate.dataErrors,
            ageEmailConfirm: emailErrors
              ? ["El correo electrónico no coincide"]
              : [],
          }));
        }

        if (findErrors) return;

        restPropertiesReservation = {
          ...valuesFormReservationGuest,
          usuFono: valuesFormRegister["uswFonoFijo1"],
          usuCelular: valuesFormRegister["uswFonoMovil"],
          isaCodigo: valuesFormRegister["isaCodigo"],
          isaCodigoImed: valuesFormRegister["isaCodigoImed"],
        };
      }

      if (
        activeTabReservation === "2" &&
        !user.isAuthenticated &&
        existPatient
      ) {
        const isaCodigoErrors =
          valuesFormRegister["isaCodigo"] === null ||
          valuesFormRegister["isaCodigo"] === undefined ||
          valuesFormRegister["isaCodigo"] === "";
        const emailErrors =
          valuesFormReservationGuest.ageEmail !==
            valuesFormReservationGuest.ageEmailConfirm ||
          valuesFormReservationGuest.ageEmail === "" ||
          valuesFormReservationGuest.ageEmail === null;
        findErrors =
          (await handleValidatePhones()) || emailErrors || isaCodigoErrors;

        if (findErrors) {
          findErrors = true;
          setErrorsReservationGuest((currentState) => ({
            ...currentState,
            ageEmail:
              valuesFormReservationGuest.ageEmail === "" ||
              valuesFormReservationGuest.ageEmail === null
                ? ["Email es obligatorio"]
                : [],
            ageEmailConfirm: emailErrors
              ? ["El correo electrónico no coincide"]
              : [],
            isaCodigo: isaCodigoErrors ? ["Convenio es obligatorio"] : [],
          }));
        }

        if (findErrors) return;

        restPropertiesReservation = {
          ...valuesFormReservationGuest,
          usuFono: valuesFormRegister["uswFonoFijo1"],
          usuCelular: valuesFormRegister["uswFonoMovil"],
          isaCodigo: valuesFormRegister["isaCodigo"],
          isaCodigoImed: valuesFormRegister["isaCodigoImed"],
        };
      }

      if (userStorage) {
        restPropertiesReservation = {
          uprRut: userStorage.uswRut,
          usuNombres: userStorage.uswNombres,
          usuApePat: userStorage.uswApePat,
          usuApeMat:
            userStorage.uswApeMat === "" || !userStorage.uswApeMat
              ? null
              : userStorage.uswApeMat,
          usuCelular: userStorage.uswFonoMovil,
          usuFono: userStorage.usuFonoCompleto,
          ageEmail: userStorage.uswEmail,
          fechaNac: userStorage.fechaNac
            ? userStorage.fechaNac.split(" ")[0].split("-").reverse().join("-")
            : null,
          isaCodigo: userStorage.isaCodigo,
          isaCodigoImed: userStorage.isaCodigoImed,
        };
      }

      dataForReservation = {
        ...dataForReservation,
        ...restPropertiesReservation,
        uprRut:
          restPropertiesReservation.uprRut || valuesFormReservationGuest.uprRut,
      };
      const response = await ReservationService.saveReservation(
        dataForReservation
      );
      const pisoBox = response.data?.data?.pisoModel || null;
      console.log("pisoBox", pisoBox);
      console.log("response", response.data);

      setSnackbar({
        openAlert: true,
        text: "Su hora ha sido agendada correctamente",
        position: {
          vertical: "bottom",
          horizontal: "right",
        },
      });

      setHourSelected((currentState) => ({
        ...currentState,
        emailPaciente: response.data?.data?.ageEmail,
        pisoBox: pisoBox,
      }));

      const modalidad = slugQuery(
        filterSearchSelected.modalidadSelected?.nombre || ""
      );
      const especialidad = slugQuery(
        filterSearchSelected.specialitySelected.value ||
          hourSelected.professional.especialidades
      );
      const nombreProfesional = slugQuery(
        hourSelected.professional.ptdNombre ||
          filterSearchSelected.professionalSelected.value
      );

      setShowModal(false);
      //history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/reserva-exitosa`)
      navigate(
        `${process.env.REACT_APP_ROOT_SERVER_PATH}/reserva-exitosa-cem?especialidad=${especialidad}&profesional=${nombreProfesional}&modalidad=${modalidad}`
      );
      // window.open(`${process.env.REACT_APP_REDIRECT_WEB}reserva-exitosa`, '_blank');
    } catch (error) {
      catchErrorApi(error);
    } finally {
      //setShowModal(false);
      setLoadingSaved(false);
    }
  };

  return {
    handleClickSaveReservation,
    loadingSaved,
    setLoadingSaved,
    hourSelected,
    setHourSelected,
    showModal,
    setShowModal,
    activeTabReservation,
    setErrorsReservationGuest,
    valuesFormReservationGuest,
    setValuesFormReservationGuest,
  };
};
